/** Identidad visual eap CONSULTING. */

export const BRAND_COLORS = {
  darkPurple: '#41446d',
  mediumPurple: '#a59cc8',
  lightLavender: '#e5cfe4',
  white: '#ffffff',
  black: '#000000',
  canvas: '#f7f2f7',
} as const;

export const BRAND_FONTS = {
  ui: '"Montserrat", "Helvetica", "Arial", sans-serif',
} as const;

export const BRAND = {
  shortName: 'eap',
  companyName: 'eap CONSULTING',
  tagline: 'Employee Assistance Program',
  version: '1.0.0',
} as const;

export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND_COLORS.darkPurple} 0%, ${BRAND_COLORS.mediumPurple} 100%)`;

export const EAP_ICON_URL = '/eap-icon.png';
